import React, { useEffect, useState } from "react";
import styled from "./ProductList.module.css";
import Icons from "../../../assets/icons";
import Image from "../../../assets/image";
import Button from "../../../components/common/button/Button";
import { Pagination } from "@mui/material";
import InputSelect from "../../../components/common/input/InputSelect";
import { useNavigate } from "react-router-dom";
import ProductDetail from "../product_detail/ProductDetail";
import callApi from "../../../services/api/apiClient";
import { useSelector } from "react-redux";
import { dispatchStore } from "../../../lib/dispatchStore";
import { requestProductSlice } from "../../../helper/customSlice";
import LoadingComponent from "../../../components/loading/LoadingComponent";
import { all } from "axios";

const ProductList = () => {
  const [selectCategory, setSelectCategory] = useState(null);
  const navigate = useNavigate();
  const [showProductDetail, setShowProductDetail] = useState(false);
  const [category, setCategory] = useState(null);
  const [productId, setProductId] = useState(null);

  const allproduct = useSelector((state) => state?.requestProductSlice?.list);

  const selectedProduct = useSelector(
    (state) => state?.requestProductSlice?.selectedProductList
  );
  const Listpage = useSelector((state) => state?.requestProductSlice?.Listpage);
  const reachEnd = useSelector((state) => state?.requestProductSlice?.reachEnd);
  const TotalPage = useSelector(
    (state) => state?.requestProductSlice?.TotalPage
  );

  useEffect(() => {
    getAllProduct(selectCategory);
  }, [Listpage]);

  useEffect(() => {
    onDefaultPage();
    callCategory();
  }, []);

  const callCategory = () => {
    callApi("product/type")
      .loadingGroup("product")
      .execute()
      .then((res) => {
        setCategory([{ id: 9999, name: "All" }, ...res]);
      });
  };

  const onDefaultPage = () => {
    console.log("Call on render function");
    dispatchStore(requestProductSlice.actions.setListpage(1));
  };

  const getAllProduct = (value) => {
    console.log("Call on render function", selectCategory);
    const param = {
      page_no: Listpage,
      per_page: 10,
      location_id: "main",
    };

    if (value === 9999) {
      param.type_id = null;
    } else {
      param.type_id = value;
    }

    console.log("param", param);

    callApi("product/getAllProduct")
      .withParam(param)
      .loadingGroup("product")
      .execute()
      .then((res) => {
        // dispatchStore(requestProductSlice.actions.setRequestProductList(res))
        if (Listpage == 1) {
          dispatchStore(
            dispatchStore(
              requestProductSlice.actions.setRequestProductList(res)
            )
          );
        } else {
          dispatchStore(
            requestProductSlice.actions.updateRequestProductList(res)
          );
        }
        // setAllproduct(res?.data)
      });
  };

  const onSelectProduct = (data) => {
    dispatchStore(requestProductSlice.actions.setSelectedProduct(data));
  };

  const onSelectedItem = (item) => {
    return selectedProduct?.find((selectedItem) => selectedItem.id === item.id);
  };

  const handleChange = (event, value) => {
    console.log("This is pagination page no", value);
    if (Listpage != undefined && reachEnd == false) {
      dispatchStore(requestProductSlice.actions.plusListpage(value));
    }
  };

  return (
    <div className="p-6" style={{ flexGrow: 1 }}>
      <LoadingComponent loadingGroup={"product"}>
        <div className="p-3">
          <div className="flex justify-between mx-6">
            <h1 className={styled.mainTitle}>Product List</h1>
            <div className="flex justify-center items-center ">
              <div className="mt-3 mr-3">
                {selectedProduct?.length > 0 && (
                  <div className="w-[20px] h-[21px] rounded-[25px] bg-red-0 top-[106px] absolute justify-center items-center flex">
                    <p className="text-xs text-white-0">
                      {selectedProduct?.length}
                    </p>
                  </div>
                )}
                <img
                  src={Icons.cart}
                  onClick={() => navigate("/add_to_cart")}
                  alt="addtocart"
                  className="w-[32px] h-[32px] mr-4 ml-[-16px]"
                />
              </div>
              {console.log("selectedProduct", category)}
              <InputSelect
                name={"category"}
                data={category}
                // className={"w-full"}
                // value={
                //   selectCategory !== null
                //     ? selectCategory === 9999
                //       ? "All"
                //       : selectCategory
                //     : "All"
                // }
                value={selectCategory}
                onChange={(event) => {
                  setSelectCategory(event.target.value);
                  if (Listpage !== 1) {
                    dispatchStore(requestProductSlice.actions.setListpage(1));
                  } else {
                    getAllProduct(event?.target?.value);
                  }
                }}
                placeholder="Select Category"
              />
            </div>
          </div>
          <div className="mt-6">
            <div className="flex flex-wrap justify-start">
              {allproduct?.length > 0 ? (
                allproduct?.map((item, index) => (
                  <div
                    key={index}
                    className={`flex flex-col mx-[10px] rounded-[2px] border mb-6 ${
                      onSelectedItem(item) ? "border-green-0" : "border-gray-2"
                    } w-[199px] flex flex-col items-center cursor-pointer`}
                  >
                    <div
                      className="w-full"
                      onClick={() => {
                        setShowProductDetail(true);
                        setProductId(item?.id);
                      }}
                    >
                      {item?.image ? (
                        <img
                          src={item?.image}
                          alt="defaultImg"
                          className="h-[140px] w-full object-cover"
                        />
                      ) : (
                        <img src={Image.defaultImg} alt="defaultImg" />
                      )}
                      <div className="p-3">
                        <p className="text-base text-blue-1 font-interSemiBold">
                          {item?.lot_no}
                        </p>
                        {/* <p className='text-black-0 text-xs'>Price : {item?.price} ks</p> */}
                      </div>
                    </div>
                    <div className="w-full px-3 pb-3">
                      <Button
                        onClick={() => {
                          onSelectProduct(item);
                        }}
                        type={"submit"}
                        className=" bg-blue-1 text-white-0 text-lg h-[48px] w-full  p-[8px] 2xl:p-[12px] rounded-[8px] lg:text-md 2xl:text-lg flex items-center justify-center mt-3"
                      >
                        Add to Cart
                      </Button>
                    </div>
                  </div>
                ))
              ) : (
                <div>
                  <p>There is no data.</p>
                </div>
              )}
            </div>
          </div>
          {console.log("HELLLO", TotalPage, Listpage)}
          {allproduct?.length > 0 && TotalPage > 1 && (
            <div className="flex justify-center mt-3  bottom-0 w-full ">
              <Pagination
                count={TotalPage}
                page={Listpage}
                onChange={handleChange}
                color="primary"
              />
            </div>
          )}
        </div>
      </LoadingComponent>
      {showProductDetail && (
        <ProductDetail
          isOpen={showProductDetail}
          onClose={() => setShowProductDetail(false)}
          id={productId}
        />
      )}
    </div>
  );
};

export default ProductList;
